import React, { useMemo } from 'react';

import { StatCard } from '@/components';
import { Callout } from '@/components/callouts/Callout';
import { Skeleton, Text } from '@/design-system/components/ui';

interface StatusCounts {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
  on_hold: number;
}

interface Props {
  isLoading?: boolean;
  isError?: boolean;
  statusCounts?: StatusCounts;
}

export const AffiliateApplicationsTotalsCards = ({ isLoading, isError, statusCounts }: Props) => {
  const elements = useMemo(
    () => [
      { label: 'Total applications', amount: statusCounts?.total },
      { label: 'Pending', amount: statusCounts?.pending },
      { label: 'On hold', amount: statusCounts?.on_hold },
      { label: 'Accepted', amount: statusCounts?.approved },
      { label: 'Rejected', amount: statusCounts?.rejected },
    ],
    [statusCounts],
  );

  if (isError)
    return (
      <div>
        <Callout title="Something went wrong" type="error" body={'Could not load applications totals'} />
      </div>
    );

  return (
    <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:lg:grid-cols-5 tw:gap-6">
      {elements.map((el, index) => (
        <StatCard key={index} label={el.label}>
          <Text variant="title-lg" as="div">
            {isLoading ? <Skeleton width={100} /> : (el.amount ?? 0)}
          </Text>
        </StatCard>
      ))}
    </div>
  );
};
